// extracted by mini-css-extract-plugin
module.exports = {"koslink":"Home_koslink__3EWhd","noitalic":"Home_noitalic__1ZBJI","m":"Home_m__30cRH","M":"Home_M__2Ioae"};